import PaginatedTable from 'components/DocumentList/PaginatedTable'
import LoadingWrapper from 'components/LoadingWrapper'
import { LOCAL_STORAGE_KEYS } from 'config'
import { DocListItem } from 'entities/Documents'
import { useMemo } from 'react'
import { useNavigation, useSearchParams } from 'react-router-dom'

type Props = {
  documents: DocListItem[]
  total: number
  page: number
  perPage: number
  selectedIDs: string[]
  setSelectedIDs: (ids: string[]) => void
  openRenameDialog?: (oID: string, name: string) => void
}
function DocumentsList({
  documents,
  total,
  page,
  perPage,
  selectedIDs,
  setSelectedIDs,
  openRenameDialog,
}: Props) {
  const navigation = useNavigation()
  const setSearchParams = useSearchParams()[1]

  const pageInvalid = perPage <= 0 || page < 0 || (total !== 0 && page * perPage >= total)
  // throwing is for debugging
  if (pageInvalid) throw Error('page invalid')

  const handlePageChange = (_e, newPage: number) => {
    setSearchParams((s) => {
      const paramNewPage =
        newPage * perPage > total ? (total === 0 ? 1 : Math.ceil(total / perPage) - 1) : newPage
      s.set('page', String(paramNewPage))
      return s
    })
    setSelectedIDs([])
  }

  const handlePerPageChange = (e) => {
    setSearchParams((s) => {
      const newPerPage = parseInt((e.target as HTMLInputElement).value, 10)
      if (page * newPerPage >= total) {
        const newPage = total === 0 ? 0 : Math.ceil(total / perPage) - 1
        s.set('page', String(newPage))
      }
      localStorage.setItem(LOCAL_STORAGE_KEYS.documentListPerPage, String(newPerPage))
      return s
    })
    setSelectedIDs([])
  }

  const rowIds = useMemo(() => (documents || []).map((d) => d.objectID), [documents])
  const filteredSelectedIDs = selectedIDs.filter((id) => rowIds.includes(id))

  return (
    <LoadingWrapper loaded={navigation.state === 'idle'}>
      <PaginatedTable
        rows={documents || []}
        page={page}
        totalCount={total}
        selectedIds={filteredSelectedIDs}
        setSelectedIds={setSelectedIDs}
        rowsPerPage={perPage}
        onPageChange={handlePageChange}
        onRowsPerPageChange={handlePerPageChange}
        openRenameDialog={openRenameDialog}
      />
    </LoadingWrapper>
  )
}

export default DocumentsList
